import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from "react-router-dom";
import { Row } from "reactstrap";
import Toast from '../../helpers/Toast';
import { GetClientMaintenancePlansRequestDTO } from '../../models/MaintenancePlan/GetClientMaintenancePlansRequestDTO';
import { GetClientMaintenancePlansResponseDTO } from '../../models/MaintenancePlan/GetClientMaintenancePlansResponseDTO';
import { ClientService } from '../../services/ClientService';
import TableComponent, { OperationsCell } from "../TableComponent";
import ButtonComponent from '../ButtonComponent';
import { useNavigateToMaintenancePlanCreate } from '../../helpers/MaintenancePlanUtilities';
import { useAvailableModulesContext } from '../../context/AvailableModulesContext';

type MaintenancePlansFromClientProps = {
    clientErpId?: string | null;
    clientName?: string | null;
};

function MaintenancePlansFromClient({ ...props }: MaintenancePlansFromClientProps) {
    const { id } = useParams<{ id: string }>();
    const clientService = new ClientService();
    const intl = useIntl();

    //#region Módulos ativos
    const { availableModules } = useAvailableModulesContext();
    const [isActiveCarPlate, setIsActiveCarPlate] = useState<boolean>(false);
    useEffect(() => {
        if (availableModules.includes("IsActiveCarPlate")) {
            setIsActiveCarPlate(true);
        }
    }, [availableModules]);
    //endregion

    const [maintenancePlans, setMaintenancePlans] = useState<GetClientMaintenancePlansResponseDTO[]>([]);
    const pageSizes: number[] = [5, 15, 30];
    const [pageSize, setPageSize] = useState<number>(pageSizes[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [goToPage, setGoToPage] = useState<number>();
    const [pageCount, setPageCount] = useState(1);

    const columns = React.useMemo(
        () => [
            {
                Header: <FormattedMessage id="Screens.MaintenancePlansFromClient.Table.Column.Numerator" />,
                accessor: "numerator",
                width: 10,
            },
            {
                Header: <FormattedMessage id="Screens.MaintenancePlansFromClient.Table.Column.Name" />,
                accessor: "name",
                width: 20,
            },
            {
                Header: <FormattedMessage id="Screens.MaintenancePlansFromClient.Table.Column.PeriodicityType" />,
                accessor: "periodicityType",
                width: 15,
            },
            ...(isActiveCarPlate ? [{
                Header: <FormattedMessage id="Screens.MaintenancePlansFromClient.Table.Column.CarPlate" />,
                accessor: "carPlate",
                width: 15,
            }] : []),
            {
                Header: <FormattedMessage id="Screens.MaintenancePlansFromClient.Table.Column.SerialNumber" />,
                accessor: "serialNumber",
                width: 15,
            },
            {
                Header: <FormattedMessage id="Screens.MaintenancePlansFromClient.Table.Column.Brand" />,
                accessor: "brand",
                width: 15,
            },
            {
                Header: <FormattedMessage id="Screens.MaintenancePlansFromClient.Table.Column.Model" />,
                accessor: "model",
                width: 15,
            },
            {
                Header: "",
                accessor: " ",
                width: 10,
                Cell: (props: any) =>
                    OperationsCell(props.cell.row.original.id, "maintenancePlan"),

            },
        ],
        [isActiveCarPlate]
    );

    const GetMaintenancePlans = async (page: number, pageSize: number) => {
        setIsLoading(true);

        const data: GetClientMaintenancePlansRequestDTO = {
            clientErpId: id!,
            currentPage: currentPage,
            pageSize: pageSize,
        }
        var response = await clientService.GetMaintenancePlansFromClient(data);

        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoading(false);

            setMaintenancePlans([]);
            setPageCount(0);
            setPageSize(0);
            setCurrentPage(0);
            setGoToPage(0);

            return;
        }

        setMaintenancePlans(response.items);
        setIsLoading(false);
    }

    useEffect(() => {
        if (id && isLoading) {
            GetMaintenancePlans(currentPage ?? 1, pageSize ?? 5)
        }
    }, [])


    //#region Navegar para criação de um novo plano, passando dados do cliente
    const navigateToCreate = useNavigateToMaintenancePlanCreate(); // tenho de fazer isto e não ser direto pq "React Hook "useNavigateToMaintenancePlanCreate" cannot be called inside a callback. React Hooks must be called in a React function component or a custom React Hook function"
    //endregion

    return (
        <div>
            <Row style={{ margin: "1rem 0px" }}>
                <ButtonComponent
                    text={intl.formatMessage({ id: "Screens.MaintenancePlansFromClient.Button.Create.MaintenancePlan" })}
                    onClick={() => navigateToCreate(props?.clientErpId, props?.clientName)}
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{ minHeight: "37px", minWidth: "100px", marginTop: "25px", marginBottom: "25px" }}
                />
            </Row>


            <Row style={{ margin: "1rem 0px" }}>
                <TableComponent
                    columns={columns}
                    data={maintenancePlans}
                    goToPage={goToPage}
                    initialPage={currentPage}
                    pageCount={pageCount}
                    initialPageSize={pageSize}
                    pageSizes={pageSizes}
                    manualPagination={true}
                    loading={isLoading}
                    fetchData={GetMaintenancePlans}
                    initialSortBy={[]}
                    disableSortBy={true}
                    dontOrderFirstCollumn={true}
                />
            </Row>
        </div>

    )
}

export default MaintenancePlansFromClient